import m from './module';

const path = '/recap/customer';

/**
 * Service for fetching customers for the recap definition editor.
 *
 * Used to populate the Customer dropdown which allows filtering
 * recap definitions by a specific customer.
 */
class CustomerService {
  constructor($q, APIService, LogService) {
    "ngInject";
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
  }

  /**
   * Get all active customers for the current client.
   *
   * @returns {Promise<Array>} Array of customer objects with {id, name}
   */
  getAll() {
    return this.APIService.get(path)
      .then(response => {
        return response.data || [];
      })
      .catch(error => {
        this.LogService.error('Failed to load customers', error);
        return [];
      });
  }
}

export default CustomerService;

m.service('CustomerService', CustomerService);

export { CustomerService };
